import {SDrawerOrModal, SLowcodeList} from "shj-components";

import {config} from './ChangeRoomAllocationStaffModalConfig.tsx'
import {getUserIdentityPage} from "@/services/user.ts";
import {getUser} from "shj-utils";
import {apiData2Table} from "@/utils/data.ts";
import {useEffect, useRef, useState} from "react";
import {message} from "antd";
import {modifyMeasurePerson} from "@/services/crmTool.ts";

interface IAddOrEditProps {
  open?: boolean
  title?: string
  reload?: (values?: object, res?: any) => void
  onClose?: (values?: object) => void
  record?: any
}

export const ChangeRoomAllocationStaffModal: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const {open, onClose, record = {}, reload} = props;
  const {companyId} = getUser()
  const listRef = useRef<any>()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open) {
      listRef.current?.clearSelectedRowKeys()
    }
  }, [open]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      if (query.userNameKeyword) {
        query.employeeFilter = {userNameKeyword: query.userNameKeyword}
        delete query.userNameKeyword
      }
      getUserIdentityPage({
        params: {pageId: current, pageSize},
        data: {
          ...query,
          companyId: companyId,
          queryEmployee: true,
          queryOrg: true
        }
      }).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onSubmit = () => {
    const [_, rows] = listRef.current?.getSelectedRows()
    if (rows.length <= 0) {
      message.error('请至少选择一条数据')
      return
    }
    setLoading(true)
    const person = rows[0]
    modifyMeasurePerson({
      id: record.id,
      userName: (person.orgName ? person.orgName + '-' : '') + person.userName,
      userIdentityId: person.id,
      userId: person.ucenterUserId
    }).then((res: any) => {
      message.success(res.message || '操作成功')
      onClose?.()
      reload?.()
    }).finally(() => {
      setLoading(false)
    })
  }

  const extension = {
    request: {fetchList}
  }

  return <SDrawerOrModal
      open={open}
      mode={'drawer'}
      title={'修改量房人'}
      onCancel={onClose}
      onOk={onSubmit}
      loading={loading}
  >
    <SLowcodeList ref={listRef} searchMode={'group'} config={config} {...extension}/>
  </SDrawerOrModal>

}